import { getDevices } from '../api';
import {
  DEVICES_FETCHING,
  DEVICES_FETCHED,
  DEVICES_FETCHED_ERROR,
} from './index';

export default function fetchDevices(groupSlug) {
  return (dispatch, getState) => {
    dispatch({ type: DEVICES_FETCHING });

    return getDevices(groupSlug)
      .then(devices => dispatch({ type: DEVICES_FETCHED, devices }))
      .catch(err => {
        console.warn(err);
        dispatch({ type: DEVICES_FETCHED_ERROR });
      });
  };
}
